const allowPartNo = {
  // Gorilla (old)
  '5040': {
    'photo': 'img_gorilla_console.png',
    'wiringPhoto': 'item_part_console_gorilla.png',
    'img': 'menu_Gorilla',
    'panel': 'LED'
  },
  // Gorilla (new)
  '0002C16A': {
    'photo': 'img_gorilla_console.png',
    'wiringPhoto': 'item_part_console_gorilla.png',
    'img': 'menu_Gorilla',
    'panel': 'LED'
  },
  // Croco H
  '0002C18B': {
    'photo': 'img_hmi_lcd_console.jpg',
    'wiringPhoto': 'item_part_console_crocoh.png',
    'img': 'menu_CrocoH',
    'panel': 'LCD'
  },
  // Croco Q light console
  '0002C18C': {
    'photo': 'img_hmi_lcd_console.jpg',
    'wiringPhoto': 'item_part_console_crocoh.png',
    'img': 'menu_CrocoH',
    'panel': 'LCD'
  },
  // Gorilla Display
  '3070': {
    'photo': 'img_hmi_lcd_display.jpg'
  },
  // Gorilla Display
  '0002P18A': {
    'photo': 'img_hmi_lcd_display.jpg'
  },
  // Gorilla Display
  '0002P19A': {
    'photo': 'img_hmi_lcd_display.jpg'
  },
  // Driver
  '0002D18A': {
    'photo': 'img_driver.jpg',
    'motorPhoto': 'img_hub_motor.png'
  },
  '0002D18C': {
    'photo': 'img_driver.jpg',
    'motorPhoto': 'img_hub_motor.png'
  },
  '0002D18B': {
    'photo': 'img_driver.jpg',
    'motorPhoto': 'img_hub_motor.png'
  },
  '0002D18D': {
    'photo': 'img_driver.jpg',
    'motorPhoto': 'img_hub_motor.png'
  },
  // Brose Motor C97272
  '97272': {
    'photo': 'img_driver_motor.png',
    'motorPhoto': 'img_driver_motor.png'
  },
  '16162': {
    'photo': 'img_driver_motor.png',
    'motorPhoto': 'img_driver_motor.png'
  },
  '91143': {
    'photo': 'img_driver_motor.png',
    'motorPhoto': 'img_driver_motor.png'
  },
  '79232': {
    'photo': 'img_driver_motor.png',
    'motorPhoto': 'img_driver_motor.png'
  },
  '97292': {
    'photo': 'img_driver_motor.png',
    'motorPhoto': 'img_driver_motor.png'
  }
};

function checkIsGorillaPN (PartNo) {
  const gorillaPN = ['5040', '0002C16A'];
  const consolePN = funcOriginalPartNo(PartNo);
  return gorillaPN.includes(consolePN);
}

/**
 * 將字串 PartNo 去頭去尾用於比對，以將不同時期生產之 part 判斷為同個 part
 *
 * PartNo 規則：
 *  [4|D|E][XXXX][C|D|P|...][YY][A-Z]{-[0-9]}
 * 1. [4|D|E] 代表開發的不同階段
 * 2. [XXXX] 代表第 XXX 號 Project
 * 3. [C|D|P|...] 代表不同的 Part Type
 * 4. [YY] 代表開案年分
 * 5. [A-Z] 代表該年分第幾個
 * 6. {-[0-9]} 可選
 *
 * @param {String} PartNo   來自 Parameter 的 PartNo
 */
function funcOriginalPartNo (PartNo) {
  const arrPartNoSplit = PartNo.split('-');
  const strPartNoRemoveDash = arrPartNoSplit[0];
  const strOriginalPartNo = strPartNoRemoveDash.substr(1);
  return strOriginalPartNo;
}

export { allowPartNo, funcOriginalPartNo, checkIsGorillaPN };
